import {useIntl} from 'react-intl';
import {HardwareTokenLoading} from '../HardwareTokenLoading/HardwareTokenLoading';
import {CertificateRow} from '../CertificateRow/CertificateRow';
import type {HardwareTokenCertificate} from '../types';
import './CertificateList.less';

interface CertificateListProps {
    certificates: HardwareTokenCertificate[];
    selectedCertificate: HardwareTokenCertificate | null;
    onSelect: (certificate: HardwareTokenCertificate) => void;
    isLoading?: boolean;
}

/**
 * Certificate list component displaying certificates as cards.
 */
export function CertificateList({
    certificates,
    selectedCertificate,
    onSelect,
    isLoading = false
}: CertificateListProps): JSX.Element {
    const {formatMessage} = useIntl();

    if (isLoading) {
        return (
            <div className="certificate-list-loading">
                <HardwareTokenLoading messageKey="hardwareToken.loadingCertificates" />
            </div>
        );
    }

    if (certificates.length === 0) {
        return (
            <div
                className="certificate-list-empty"
                data-wdio="test-certificate-list-empty"
            >
                <p className="certificate-list-empty-message">
                    {formatMessage({
                        id: 'oss.personal_certificate_client.error.empty_certificate_list',
                        defaultMessage: 'No certificates found'
                    })}
                </p>
            </div>
        );
    }

    return (
        <div
            className="certificate-list"
            data-wdio="test-certificate-list"
            role="listbox"
            aria-label={formatMessage({
                id: 'hardwareToken.certificateListLabel',
                defaultMessage: 'Available certificates'
            })}
        >
            {certificates.map((certificate) => (
                <CertificateRow
                    key={certificate.serial}
                    certificate={certificate}
                    isSelected={selectedCertificate?.serial === certificate.serial}
                    onSelect={onSelect}
                />
            ))}
        </div>
    );
}
